module.exports = __webpack_public_path__ + "static/media/custom_inspection_check_icon.8413ebc0.png";